import { SUPERADMINFREELANCELOCATIONLIST } from "../../ENVIRONMENT";
// api for location
function freelanceListLocation(token) {
  const response = fetch(SUPERADMINFREELANCELOCATIONLIST, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { freelanceListLocation };
